import { Box, Skeleton } from "@mui/material";

const ScenarioSelectorsSkeleton = () => {
  return (
    <Box className="w-full flex space-x-4">
      <Box sx={{ minWidth: 180 }}>
        <Skeleton
          variant="rounded"
          height={56}
          sx={{ borderRadius: 1, minWidth: 180 }}
        />
      </Box>
      <Box sx={{ minWidth: 180 }}>
        <Skeleton
          variant="rounded"
          height={56}
          sx={{ borderRadius: 1, minWidth: 180 }}
        />
      </Box>
    </Box>
  );
};

export default ScenarioSelectorsSkeleton;
